import {axiosInstance} from "@/plugins/axios";
import {MaterialDeclarationTransactionFilter} from "@/modules/material_declaration_transaction/types"
import {MaterialDeclarationTransaction} from "@/modules/material_declaration_transaction/types"

export async function getMaterialDeclarationTransactions(payload: MaterialDeclarationTransactionFilter) {
  let url = 'material_declaration_transactions?';

  if (payload && payload.start_application_date !== "" && payload.end_application_date !== "") {
    url += `start_application_date=${payload.start_application_date}&end_application_date=${payload.end_application_date}&`
  }

  if (payload && payload.id_supplier) {
    url += `id_supplier=${payload.id_supplier}&`
  }

  if (payload.limit) {
    url += `limit=${payload.limit}&offset=${payload.offset}`;
  }
  const response = await axiosInstance.get(url);
  return response.data;
}

export async function saveMaterialDeclarationTransaction(materialDeclarationTransaction: MaterialDeclarationTransaction) {
    const response = await axiosInstance.post(`material_declaration_transactions`, materialDeclarationTransaction);
    return response.data;
  }
  
export async function saveMaterialDeclarationTransactions(materialDeclarationTransaction: MaterialDeclarationTransaction[]) {
    const response = await axiosInstance.post(`material_declaration_transactions/create_or_update_many`, {
      material_declaration_transactions: materialDeclarationTransaction
    });
    return response.data;
  }